import React from 'react';

const variants = {
  primary:
    'bg-green-700 hover:bg-green-800 text-white focus-visible:ring-green-600 disabled:bg-green-700/60',
  secondary:
    'bg-white hover:bg-gray-50 text-gray-900 border border-gray-300 focus-visible:ring-gray-400 disabled:bg-gray-50',
  ghost:
    'bg-transparent hover:bg-gray-100 text-gray-700 focus-visible:ring-gray-300 disabled:opacity-60',
  danger:
    'bg-red-600 hover:bg-red-700 text-white focus-visible:ring-red-500 disabled:bg-red-600/60',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-base',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  ...rest
}) {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`}
      {...rest}
    />
  );
}
